module.exports = __webpack_public_path__ + "media/images/lb/127-977da4b5587f509603d00cbaecfa69ce.svg";